export default "__VITE_ASSET__16974764__"